import {
  OPEN_PLATFORM_PARTNER_CONSENT_PAGE_REQUEST,
  OPEN_PLATFORM_PARTNER_CONSENT_REGISTER_MERCHANT_CONSENT,
  OPEN_PLATFORM_PARTNER_CONSENT_SET_PARTNER_DETAIL,
  OPEN_PLATFORM_PARTNER_CONSENT_SET_ACTION_ALLOW,
  OPEN_PLATFORM_PARTNER_CONSENT_SET_ACTION_DENY,
  OPEN_PLATFORM_PARTNER_CONSENT_SET_ACTION_ERROR,
  OPEN_PLATFORM_PARTNER_CONSENT_SET_ERROR_MESSAGE,
  OPEN_PLATFORM_PARTNER_CONSENT_RESET_ERROR_MESSAGE,
  OPEN_PLATFORM_PARTNER_CONSENT_RESET,
} from './constants';

export function pageRequest(id) {
  return {
    type: OPEN_PLATFORM_PARTNER_CONSENT_PAGE_REQUEST,
    payload: { id },
  };
}

export function registerMerchantConsent(id, redirectUri) {
  return {
    type: OPEN_PLATFORM_PARTNER_CONSENT_REGISTER_MERCHANT_CONSENT,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    payload: { id, redirect_uri: redirectUri },
  };
}

export function setPartnerDetail({ partnerDetail }) {
  return {
    type: OPEN_PLATFORM_PARTNER_CONSENT_SET_PARTNER_DETAIL,
    payload: { partnerDetail },
  };
}

export function showAllowModal() {
  return { type: OPEN_PLATFORM_PARTNER_CONSENT_SET_ACTION_ALLOW, payload: {} };
}

export function showDenyModal() {
  return { type: OPEN_PLATFORM_PARTNER_CONSENT_SET_ACTION_DENY, payload: {} };
}

export function showErrorModal() {
  return { type: OPEN_PLATFORM_PARTNER_CONSENT_SET_ACTION_ERROR, payload: {} };
}

export function setErrorMessage({ errorMessage }) {
  return {
    type: OPEN_PLATFORM_PARTNER_CONSENT_SET_ERROR_MESSAGE,
    payload: { errorMessage },
  };
}

export function resetErrorMessage() {
  return {
    type: OPEN_PLATFORM_PARTNER_CONSENT_RESET_ERROR_MESSAGE,
    payload: {},
  };
}

export function reset() {
  return { type: OPEN_PLATFORM_PARTNER_CONSENT_RESET, payload: {} };
}
